import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import artieLogo from "@/assets/images/artie.png";

const Navbar = () => {
  const { user, logout } = useAuthStore();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  return (
    <header className="bg-white border-b border-neutral-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Left side - Logo */}
          <Link to="/brand-dashboard" className="flex items-center hover:opacity-80 transition-opacity">
            <img src={artieLogo} alt="Artie" className="w-10 h-10 mr-3" />
            <span className="font-work font-semibold text-3xl text-neutral-900 tracking-normal">artie</span>
          </Link>
          
          {/* Center - Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/brand-dashboard" className="text-neutral-600 hover:text-neutral-900 font-medium">
              Home
            </Link>
            <Link to="/campaigns" className="text-neutral-900 font-semibold">
              Campaigns
            </Link>
            <span className="text-neutral-600 hover:text-neutral-900 font-medium cursor-pointer">IO & Payments</span>
            <span className="text-neutral-600 hover:text-neutral-900 font-medium cursor-pointer">Settings</span>
          </nav>
          
          {/* Right side - User info */}
          <div className="flex items-center space-x-4">
            <div className="relative">
              <button
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                className="flex items-center space-x-2 text-sm text-neutral-600 hover:text-neutral-900 transition-colors"
              >
                <span className="bg-neutral-100 px-3 py-1 rounded-full font-medium">
                  {user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || 'U'}
                </span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isProfileDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {/* Dropdown Menu */}
              {isProfileDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-neutral-200 rounded-lg shadow-lg z-50">
                  <div className="py-2">
                    <div className="px-4 py-2 border-b border-neutral-100">
                      <p className="text-sm font-medium text-neutral-900">{user?.name || 'User'}</p>
                      <p className="text-xs text-neutral-500">{user?.email || 'user@example.com'}</p>
                    </div>
                    <div className="pt-2">
                      <button
                        onClick={() => {
                          setIsProfileDropdownOpen(false);
                          logout();
                        }}
                        className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                      >
                        <LogOut className="w-4 h-4 mr-3" />
                        Sign Out
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;